module.exports = __webpack_public_path__ + "img/4.034d50e9.png";